import React, { useEffect, useRef, useCallback } from 'react';
import AntSearchChart from './AntSearchChart';
import AntToolbar from './AntToolbar';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default function (props) {
    var [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url || props.table || props.loadFunc));

    var handleLoaded = useCallback((dataRows) => {
        if (props.onEmpty) {
            var rows = dataRows && dataRows.data instanceof Array ? dataRows.data : [];
            props.onEmpty(rows.length === 0);
        }
        markLoaded();
    }, [markLoaded]);
    let storageKey = props.storageKey
        ? props.storageKey
        : 'widget-chart-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    const chart = useRef();

    useEffect(() => {
        var ms = ((props.refreshIntervalSec ?? 0) | 0) * 1000;
        if (ms <= 0) return;
        var iv = setInterval(function () {
            try { if (chart.current && chart.current.refresh) chart.current.refresh(); } catch (e) {}
        }, ms);
        return () => clearInterval(iv);
    }, [props.refreshIntervalSec]);

    return (
        <React.Fragment>
            {props.showTitle !== false && (
                <AntToolbar
                    title={props.title ? props.title : props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    showHelp={props.showHelp}
                    isH6={true}
                    upperCase={true}
                    // upperCase={props.upperCase}
                />
            )}

            <div className="ant-widget-skeleton-host">
                    {!loaded && <AntWidgetSkeleton variant="chart" overlay={true} height={props.height} />}
                    <AntSearchChart
                    ref={chart}
                    API={props.API}
                    table={props.table}
                    url={props.url}
                    entityName={props.entityName}
                    entityDisplay={props.entityDisplay}
                    loadFunc={props.loadFunc}
                    searchConditions={props.searchConditions}
                    searchFields={props.searchFields}
                    showActionBar={props.showActionBar !== undefined ? props.showActionBar : false}
                    showSearchBar={props.showSearchBar}
                    showRefresh={props.showRefresh}
                    locationRefresh={props.locationRefresh}
                    locationSearchBar={props.locationSearchBar}
                    fields={props.fields}
                    actionItems={props.actionItems}
                    storageKey={storageKey}
                    keyExpr={props.keyExpr}
                    hideHeaderMargin={true}
                    argumentField={props.argumentField}
                    argumentFormat={props.argumentFormat}
                    queryFields={props.queryFields}
                    seriesTemplate={props.seriesTemplate}
                    commonSeriesSettings={props.commonSeriesSettings}
                    series1={props.series1}
                    series2={props.series2}
                    series3={props.series3}
                    series4={props.series4}
                    valueAxis={props.valueAxis}
                    argumentAxis={props.argumentAxis}
                    showLegend={props.showLegend}
                    legend={props.legend}
                    height={props.height}
                    width={props.width}
                    rotated={props.rotated}
                    palette={props.palette}
                    onLoaded={handleLoaded}
                    />
            </div>
        </React.Fragment>
    );
}
